import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const Plus: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.7368 6.73684H9.26316V1.26316C9.26316 0.566625 8.69653 0 8 0C7.30347 0 6.73684 0.566625 6.73684 1.26316V6.73684H1.26316C0.566625 6.73684 0 7.30347 0 8C0 8.69653 0.566625 9.26316 1.26316 9.26316H6.73684V14.7368C6.73684 15.4334 7.30347 16 8 16C8.69653 16 9.26316 15.4334 9.26316 14.7368V9.26316H14.7368C15.4334 9.26316 16 8.69653 16 8C16 7.30347 15.4334 6.73684 14.7368 6.73684Z"
        fill="currentColor"
      />
    </svg>
  )
})

Plus.displayName = 'Plus'
